module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }